/* eslint-disable import/prefer-default-export */
import styled from '@emotion/styled';
import { keyframes } from '@emotion/core';

const rotation = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

export const SpinnerBox = styled.div`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 50px;
  max-width: 50px;
  height: 50px;
  max-height: 50px;
  &:after {
    content: '';
    display: block;
    width: 100%;
    max-width: 32px;
    height: 100%;
    max-height: 32px;
    margin: 8px;
    border-radius: 50%;
    border: 4px solid ${(props) => props.color};
    border-color: ${(props) => props.color} transparent ${(props) => props.color} transparent;
    animation: ${rotation} 1.2s linear infinite;
    z-index: 2;
  }
  &:hover:after {
    border: 4px solid ${(props) => props.hoverColor};
    border-color: ${(props) => props.hoverColor} transparent ${(props) => props.hoverColor} transparent;
  }
`;
